import { apiClient } from "./apiClient";

// Phase 4B: send the record's last-known version so the server can reject a
// stale overwrite with 409. See api_v2/concurrency.py.
export function putWithVersion(url, payload, version) {
  const config = version ? { headers: { "X-Expected-Version": String(version) } } : {};
  return apiClient.put(url, payload, config);
}

// Phase 4B (routes): POST an action while sending the record's last-known
// version so the server can reject a stale route edit with 409.
export function postWithVersion(url, payload, version) {
  const config = version ? { headers: { "X-Expected-Version": String(version) } } : {};
  return apiClient.post(url, payload, config);
}

export function isVersionConflict(error) {
  return (
    error?.response?.status === 409 &&
    error?.response?.data?.detail?.code === "version_conflict"
  );
}

export function conflictMessage(error) {
  return (
    error?.response?.data?.detail?.message ||
    "This record was updated by another admin. Review the latest changes before saving."
  );
}

export function conflictLatest(error) {
  return error?.response?.data?.detail?.latest || null;
}
